<template>
  <section class="kceThankYou" v-if="submitted">
    <h1 class="kce-headline">Thank you!</h1>
    <p>{{ thankYouMessage }}</p>
  </section>
  <section class="kceRegFormWrap" v-else-if="quizPassed">
    <br />
    <h1 class="kce-headline">So that was genius</h1>
    <div class="kceForm_intro">
      <h2 class="kceForm_header">
        Congratulations! <br />
        You're now a keno certified expert!
      </h2>
      <p>
        You re now eligible for exclusive promos, swag, social connections and
        exciting events!
      </p>
      <p>
        Fill out the form below and you'll receive a free KENO t-shirt to
        identify yourself as an expert on the topic.
      </p>
    </div>
    <div v-if="!submitted" class="kce-register-form kce-container">
      <form
        data-abide
        novalidate
        data-validate-on-blur="true"
        id="registerForm"
      >
        <section class="regLogInFields">
          <h3>Your Info *</h3>
          <span class="note">*Required fields.</span>
          <div class="grid-x grid-margin-x grid-margin-y">
            <div class="cell medium-6 input-wrapper">
              <input
                type="text"
                id="fname"
                v-model="firstName"
                placeholder=""
                required
              />
              <label for="fname">First Name* </label>
              <span class="error"> Field is required. </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input
                type="text"
                id="lname"
                placeholder=""
                v-model="lastName"
                required
              />
              <label for="lname">Last Name* </label>
              <span class="error"> Field is required. </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input
                type="text"
                id="job-title"
                v-model="jobTitle"
                placeholder=""
                required
              />
              <label for="job-title">Job Title*</label>
              <span class="error">
                Field is required.
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input
                type="text"
                id="phoneInput"
                placeholder=""
                v-model="phoneNumber"
                required
                pattern="^\d{3}-\d{3}-\d{4}$"
              />
              <label for="phoneInput">Phone Number*</label>
              <span class="error">
                A valid phone number is required.
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <label class="visuallyhidden" for="select">Shirt Size*</label>
              <select id="select" required v-model="shirtSize">
                <option disabled value="_none">Shirt Size*</option>
                <option value="small">Small t-shirt (unisex)</option>
                <option value="medium">Medium t-shirt (unisex)</option>
                <option value="large">Large t-shirt (unisex)</option>
                <option value="xlarge">XL t-shirt (unisex)</option>
                <option value="xxlarge">XXL t-shirt (unisex)</option>
                <option value="xxxlarge">XXXL t-shirt (unisex)</option>
                <option value="small_tank">Small tank top (womens)</option>
                <option value="medium_tank">Medium tank top (womens)</option>
                <option value="large_tank">Large tank top (womens)</option>
                <option value="xlarge_tank">XL tank top (womens)</option>
                <option value="xxlarge_tank">XXL tank top (womens)</option>
              </select>
              <span class="error">
                Please select a shirt size
              </span>
            </div>
               <div class="cell medium-6 input-wrapper">
              <input
                type="email"
                id="email"
                placeholder=""
                v-model="email"
                required
              />
              <label for="email">Email Address*</label>
              <span class="error" v-if="!emailValid">
                A valid email is required.
              </span>
            </div>
          </div>
          <div class="grid-x grid-margin-x grid-margin-y">
         
            <div class="cell medium-6 input-wrapper">
              <input
                type="password"
                v-model="password"
                id="password"
                placeholder=""
                pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$"
                required
              />
              <label for="password">Password*</label>
              <password v-model="password" :strength-meter-only="true" />

              <span class="error" v-if="!passwordValid">
                Please create your password
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input
                type="password"
                id="password-match"
                placeholder=""
                aria-describedby="passwordHint"
                data-equalto="password"
                required
              />
              <label for="password-match">Confirm Password*</label>
              <span class="error" v-if="!passwordMatch">
                Passwords do not match
              </span>
            </div>
            <p class="help-text" id="passwordHint">
              Your password must be at least eight characters long and include
              an uppercase letter AND a lowercase letter AND a number.
            </p>
          </div>
        </section>
        <section class="employerInfo">
          <h3>Employer Info*</h3>
          <div class="grid-x grid-margin-x grid-margin-y">
            <div class="cell medium-6 input-wrapper">
              <input type="text" id="employer-name" placeholder="" v-model="employerName" required />
              <label for="employer-name">Employer Name*</label>
              <span class="error">
                Field is required.
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input type="text" id="address" placeholder="" v-model="mailingAddress" required />
              <label for="address">Address*</label>
              <span class="error">
                Field is required.
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input
                type="text"
                v-model="city"
                id="city"
                placeholder=""
                required
              />
              <label for="city">City*</label>
              <span class="error">
                Field is required.
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input type="text" id="zip" placeholder="" v-model="zipcode" required />
              <label for="zip">Zip Code*</label>
              <span class="error">
                Field is required.
              </span>
            </div>
            <div class="cell medium-6 input-wrapper">
              <input type="text" id="retailer-code" placeholder=""  v-model="retailerCode"/>
              <label for="retailer-code">Retailer Code</label>
            </div>
          </div>
        </section>
        <div class="register__form-action">
          <button
            class="kce-btn-secondary"
            id="kceSubmit"
            name="kceSubmit"
            @click="(e)=>submit(e)"
          >Make it Official</button>
        </div>
      </form>
    </div>
  </section>
  <KceBlockedMessage v-else/>
</template>

<script>
import { email } from "@vuelidate/validators";

import KceBlockedMessage from '../KceBlockedMessage.vue';
import Password from 'vue-password-strength-meter';
import moment from 'moment';


export default {
  props: {
    successurl: String,
    assignrole: Number,
  },
  components: {
    KceBlockedMessage,
    Password
  },
  data: function () {
    return {
      thankYouMessage: "You are now registered as a Keno Certified Expert!",
      userName: "",
      password: null,
      firstName: "",
      lastName: "",
      mailingAddress: "",
      city: "",
      state: "OH",
      zipcode: "",
      country: "USA",
      email:"",
      shirtSize:"_none",
      registerApiToken: "",
      registerErrorMsg: "",
      formEnable: true,
      formSuccess: false,
      jobTitle:"",
      retailerCode:"",
      employerName:"",
      phoneNumber:"",
      phoneInput: document.getElementById("phoneInput"),
      successful: false,
      unsuccessful: false,
      deleted: false,
      submitted: false,
      userIsAuthed: false,
      RegistrationType: "",
      minimumAppVersion: "",
      emailValid: true,
      passwordValid: true,
      passwordMatch: false,
      error: false,
      quizPassed: false
    };
  },
  mounted: function () {
    let cookie =  this.getCookie("stepTracker");
    if(cookie === "registration"){
        this.quizPassed = true;
    }else if(cookie === "registered"){
       this.submitted = true;
       this.thankYouMessage = "Looks like you are already a Keno Certified Expert!"
    }
    $(document).foundation();
    this.getToken();
    console.log(this.assignrole)
    this.RegistrationType = this.assignrole;
    this.phoneNumberFormat(this.phoneInput);
    this.setAppVersion()
  },
  methods: {
    formValidate() {
        let valid = false;
        valid = this.validate();
        if (valid === true) {
            this.error = false;
            // this.$refs.uspsValidate.validate()
        } else {
            this.error = true;
        }
    },
    validate() {
        this.error = false;
        let emailReg = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g),
            passwordReg = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/),
            valid = false,
            email = this.email,
            password1 = this.password,
            password2 = $('#password-match').val(),
            phone = $('#phoneInput').val();

        this.emailValid = emailReg.test(email),
        this.passwordValid = passwordReg.test(password1);

        //#region text validation 
        let required = $("*:required")
        let invalidFields = [];
        console.log(required)
        required.each((index,field)=>{
            if(field.value === "" || field.value === null || field.value === undefined || field.value === "_none"){
                invalidFields.push(field)
                console.log("#" + field.id +" + .error");
                $("#" + field.id + " ~ .error").show();
                if(field.id === "#password"){
                    this.passwordValid = false
                }else if (field.id === "#email"){
                    this.emailValid = false
                }

            }else{
                $("#" + field.id + " ~ .error").hide();
            }
        })
             if(password1 === password2) {
            this.passwordMatch = true;
        } else {
            this.passwordMatch = false;
             $("#password-match ~ .error").show();
            this.error = true;
        }
        console.log(invalidFields.length >=1)
        this.phoneValid = this.phoneValidation(phone);
        if (invalidFields.length >=1) {
            valid = false;
            this.error = true;
            invalidFields = [];
            console.log("there was an error in the required fields..")
        } else {
            if (this.passwordValid===true && this.emailValid===true && this.phoneValid===true){
                valid = true;
               
            } else{
                 console.log("error with email or password", "password: ", this.passwordValid, " email: ", this.emailValid)
                  valid = false;
                this.error = true;
            }
            
        }
        return valid;
    },
    getToken() {
        // then hit API with token
        this.getAPItoken()
        .then((token) => {
            this.fetchData(token);
        });
    },
    fetchData(token) {
        var apiToken = token;
        this.registerApiToken = apiToken;
        var urlProtocol = this.getProtocol();
        return fetch(urlProtocol+process.env.VUE_APP_APIURL+"/1.0/Games/StaticContentElements/StaticContentElement/GetContentElementByKey?contentKey=terms-conditions", {
            headers: {
                'Authorization': 'Bearer '+apiToken,
            },
        })
        .then(response => response.json())
        .then(json => {
            var terms = json.data;
            this.termsTitle = terms[0]['title'];
            this.termsContent = terms[0]['centralContent'];
        })
        .catch(error => {
            // console.error("There was an error!", error);
            return this.errorMessage = error;
        });
    },
    submit(e) {
        e.preventDefault();
        this.formValidate();
        console.log(this.valid)
        if ( this.error === false){
          let confirmBodyRegister = {
                    "firstName": this.firstName,
                    "lastName": this.lastName,
                    "jobTitle":this.jobTitle,
                    "phoneNumber": this.phoneNumber,
                    "shirtSize":this.shirtSize,
                    "email": this.email,
                    "userName": this.email,
                    "password": this.password,
                    "employerName":this.employerName,
                    "address": {
                        City: this.city,
                        State: this.state,
                        Address: this.mailingAddress,
                        ZipCode: this.zipcode
                    },
                    "employerAddress": {
                        City: this.city,
                        State: this.state,
                        Address: this.mailingAddress,
                        ZipCode: this.zipcode
                    },
                    "retailerCode":this.retailerCode,
                    // "npiPlayerID": "string"
                    "registrationType": this.RegistrationType,
                    "appVersion": this.minimumAppVersion
                }
          const confirmRegisterOptions = {
                    method: 'POST',
                    headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+ this.registerApiToken
                    },
                    body: JSON.stringify(confirmBodyRegister)
                };

                fetch("https:"+process.env.VUE_APP_APIURL+"/1.0/PAM/RegisterUser", confirmRegisterOptions)
                .then(response => response.json())
                .then(dataRegister => {
                    console.log(dataRegister)
                    // $('#errorAddressModal').foundation('close');
                    if( dataRegister.data == null ){
                        this.formEnable = true;
                        this.formSuccess = false;
                        this.submitted = false;
                        this.registerErrorMsg = dataRegister.error.message;
                        console.log("there was an error", this.registerErrorMsg)
                        if (this.registerErrorMsg === "The User is already in use"){
                          this.formEnable = false;
                           this.formSuccess = true;
                          this.submitted = true;
                           document.cookie = "stepTracker=registered";
                          this.thankYouMessage = "Looks like you are already a Keno Certified Expert!"
                        }
                    }else{
                        console.log("success!", dataRegister.message)
                        if (dataRegister.message === "Keno Certified Expert role added"){
                          this.thankYouMessage = "Your account has been updated, you are now registered as a Keno Certified Expert!"
                        }
                        this.formEnable = false;
                        this.formSuccess = true;
                        this.submitted = true;
                         document.cookie = "stepTracker=registered";
                       // window.location.href = this.successurl;
                    }
                });
            }
        },
    setAppVersion () {
        let url = window.location.origin + '/registration/GetMinimumAppVersion';
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json'
            }
        }).then((response) => response.json())
        .then((json) => {
            this.minimumAppVersion = json.minAppVersionNumber;
        })
        .catch((error) => {
            return (this.errorMessage = error)
        })
    }
    },
  computed: {},
};
</script>

<style lang="scss" scoped>
input,
select {
  height: auto;
  line-height: inherit;
}

.form-error-birth {
  margin-top: -0.5rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
  font-weight: bold;
  color: #cc4b37;
  display: block;
}

.error{
display: none;
}

.terms {
  overflow: auto;
  height: 200px;
  width: 100%;
  padding: 10px;
  margin: 0 0 10px;
  background: #fff;
  border: 1px solid #b9bdc3;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background-clip: padding-box;
}
</style>
